import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { setCompanies } from '../actions/companies.actions';
import { Company } from '../models/office.model';

export const initialState: Company[] = [];

const reducer = createReducer(initialState,
  on(setCompanies, (state, { companies }) => companies)
);

export const fromCompanies = {
  selectCompaniesState: createFeatureSelector<Company[]>('companies'),

  selectFilteredCompanies: (searchText: string) => createSelector(
    (state: { companies: Company[] }) => state.companies,
    (companies: Company[]) => companies.map(company => ({
      ...company, offices: company.offices.filter(office => office.selectName.toLowerCase().includes(searchText.toLowerCase()))
    }))
  ),
};

export function companiesReducer(state, action) {
  return reducer(state, action);
}
